<template>
  <!-- The row is a div, so it carries the focus and key handling a clickable entry needs itself -->
  <ListboxItem
    v-bind="$props"
    tabindex="0"
    @click="close"
    @keydown.enter.prevent="activate"
    @keydown.space.prevent="activate"
  >
    <template v-if="$slots.prefix" #prefix>
      <slot name="prefix" />
    </template>
    <template v-if="$slots.suffix" #suffix>
      <slot name="suffix" />
    </template>
  </ListboxItem>
</template>

<script setup lang="ts">
import { inject } from 'vue';

import { ListboxItemProps } from '../listbox/listbox-item-props.interface';
import ListboxItem from '../listbox/listbox-item.vue';
import { menuButtonInjectionKey } from './menu-button.token';

const props = defineProps<ListboxItemProps & { manualClose?: boolean }>();

const menuButton = inject(menuButtonInjectionKey);

function close() {
  if (!props.manualClose) {
    menuButton?.close();
  }
}

/** Enter and Space run the same click the mouse would, so the item needs no separate handler */
function activate(event: KeyboardEvent) {
  (event.currentTarget as HTMLElement).click();
}
</script>
